<template>
  <div>
    <AdBridgeImportAgentActions
      v-if="item.type === importAgent"
      :containerClass="$style.container"
      :handleDelete="handleDelete"
      :iconButtonClass="$style.iconButton"
      :item="item"
    />
    <AdBridgeSyncAgentActions
      v-if="item.type === syncAgent"
      :containerClass="$style.container"
      :handleDelete="handleDelete"
      :iconButtonClass="$style.iconButton"
      :item="item"
    />
  </div>
</template>
<script>
import { AdBridgeAgentTypes, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions } from 'vuex';
import AdBridgeImportAgentActions from 'client/components/ItemTable/BodyComponents/AdBridgeImportAgentActions.vue';
import AdBridgeSyncAgentActions from 'client/components/ItemTable/BodyComponents/AdBridgeSyncAgentActions.vue';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

const storeModule = StoreModuleMap[ItemTypeConsts.adBridgeAgent];

export default {
  name: 'AdBridgeAgentActions',

  components: {
    AdBridgeImportAgentActions,
    AdBridgeSyncAgentActions,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      ...AdBridgeAgentTypes,
    };
  },

  methods: {
    ...mapActions(storeModule, [
      'delete',
    ]),

    handleDelete() {
      const componentProps = {
        headerText: 'Delete Domain Agent',
        bodyText: 'Are you sure you want to delete the selected Domain Agent?',
        continueText: 'yes, delete',
        handleCancel: () => ModalEventBus.close(),
        handleContinue: () => {
          ModalEventBus.close();
          this.delete(this.item.id);
        },
        mainActionAttention: true,
        showClose: true,
      };

      ModalEventBus.open({
        isLargeModal: false,
        component: ConfirmationModal,
        componentProps,
      });
    },
  },
};
</script>
<style module>
.container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.container .iconButton {
  margin: 0 0.25rem 0.25rem 0.25rem;
}
</style>
